import React from 'react';

import { BloodworkEntry } from '../components/bloodworkz/bloodwork-entry';
import { BloodworkDisplay } from '../components/bloodworkz/bloodwork-display';

import { observer, inject } from 'mobx-react';
import { BloodworkEntryStore } from '../stores/bloodwork-entry-store';
import { UserStore } from '../stores/user-store';
import { ClientEntryStore } from '../stores/client-entry-store';
import { FurtherConsiderationsEntryStore } from '../stores/further-considerations-entry-store';
import { UserProfileUIStore } from '../stores/user-profile-ui-store';
import { Client } from '../models/Client';
import { Container } from 'react-bootstrap';

interface BloodworkEntryContainerProps {
  match?: any;
  bloodworkEntryStore?: BloodworkEntryStore;
  userStore?: UserStore;
  userProfileUIStore?: UserProfileUIStore;
  clientEntryStore?: ClientEntryStore;
  furtherConsiderationsEntryStore?: FurtherConsiderationsEntryStore;
  history?: any;
  path?: any;
}

@inject(
  'bloodworkEntryStore',
  'userStore',
  'userProfileUIStore',
  'clientEntryStore',
  'furtherConsiderationsEntryStore',
)
@observer
export class BloodworkEntryContainer extends React.Component<
  BloodworkEntryContainerProps,
  {}
> {
  componentDidMount() {
    const {
      userProfileUIStore,
      bloodworkEntryStore,
      clientEntryStore,
      furtherConsiderationsEntryStore,
    } = this.props;
    userProfileUIStore.loadCurrentUserProfile();
    bloodworkEntryStore.loadBloodworkRanges();
    clientEntryStore.loadCurrentClients();
    furtherConsiderationsEntryStore.loadFurtherConsiderations();
  }

  findClient(clientId: string): Client {
    return clientId && this.props.clientEntryStore.clients
      ? Client.findClient(clientId, this.props.clientEntryStore.clients)
      : new Client();
  }

  render() {
    const {
      bloodworkEntryStore,
      userStore,
      userProfileUIStore,
      clientEntryStore,
      furtherConsiderationsEntryStore,
      match,
    } = this.props;

    return (
      <Container fluid>
        <BloodworkEntry
          hideEnterTestResults={bloodworkEntryStore.hideEnterTestResults}
          selectedClient={this.findClient(match.params.clientId)}
          currentUser={userStore.currentUser}
          currentUserProfile={userProfileUIStore.currentUserProfile}
          currentClients={clientEntryStore.clients}
          bloodwork={bloodworkEntryStore.currentBloodwork}
          bloodworkRanges={bloodworkEntryStore.bloodworkRanges}
          bloodworkEntryStore={bloodworkEntryStore}
          refreshBloodworks={bloodworkEntryStore.refreshBloodworks}
          updateClient={(client) => clientEntryStore.updateClientFields(client)}
          history={this.props.history}
          path={this.props.path}
        />

        <BloodworkDisplay
          currentUserProfile={userProfileUIStore.currentUserProfile}
          testResultsPanelLabel="Test Results"
          bloodworks={bloodworkEntryStore.bloodworks}
          bloodworkEntryStore={bloodworkEntryStore}
          refreshBloodworks={bloodworkEntryStore.refreshBloodworks}
          furtherConsiderations={
            furtherConsiderationsEntryStore.furtherConsiderations
          }
          history={this.props.history}
          showAnalyzeTableButton={true}
          updateClient={(client) => clientEntryStore.updateClientFields(client)}
          currentClients={clientEntryStore.clients}
        />
      </Container>
    );
  }
}
